import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const WelcomeScreen = ({
  setScreenNumber,
  handleNextScreen,
  telegramLink,
  isVisibleModal,
  setIsVisibleModal
}) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.title}>
          Дякуємо,<br></br>
          що завітав!
        </p>
        <p className={styles.description}>
          Тут на тебе чекає багато<br></br>
          різного контенту.<br></br>
          Починаємо?
        </p>
        <button className={styles.nextButton} onClick={handleNextScreen}>
          Далі
        </button>
        <div className={styles.footer}>
          Натискаючи «ДалI» ти робиш запит на отримання інформації про продукцію
          компанії Філіп Морріс засобами дистанційного зв'язку відповідно до
          частини 2 статті 15 Закону «Про захист прав споживачів» та
          підтверджуєш, що Є СПОЖИВАЧЕМ ТЮТЮНОВИХ ВИРОБІВ ТА/АБО КОРИСТУВАЧЕМ
          ПРИСТРОЇВ ДЛЯ СПОЖИВАННЯ ТЮТЮНОВИХ ВИРОБІВ БЕЗ ЇХ ЗГОРЯННЯ“.
        </div>
        {/*<button className={styles.skipButton}>Пропустити</button>*/}
      </div>
      <div className={styles.buttonContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(2)}>Умови використання</button>
        <button onClick={() => setScreenNumber(3)}>FAQ</button>
        <button onClick={() => setScreenNumber(4)}>
          Параметри застосування файлів cookie
        </button>
      </div>
      {isVisibleModal && (
        <div className={styles.modal}>
          <p className={styles.text}>
            Ми використовуємо файли cookie та подібні технології для надання
            персоналізованого досвіду (відповідно до вашої поведінки в Інтернеті
            на цьому та інших веб-сайтах), для релевантного відображення
            оголошень, контенту і доречної комунікації; для поліпшення сайту;
            роботи сайту; і щоб пам'ятати ваші уподобання. Натисніть «Дізнатися
            більше» для отримання додаткової інформації або для налаштування
            параметрів. Ви можете змінити свою думку в будь-який час, відвідавши
            «Налаштування файлів cookie». Будь-які ваші персональні дані будуть
            використовуватися, як описано в нашій
          </p>
          <a
            className={styles.policyLink}
            href="https://www.pmiprivacy.com/ukraine/uk/consumer/"
          >
            Політиці конфіденційності
          </a>
          <div className={styles.buttonContainer}>
            <button onClick={() => setIsVisibleModal(false)}>
              Погоджуюся з усім
            </button>
            <button
              onClick={() => {
                setIsVisibleModal(false);
                setScreenNumber(4);
              }}
            >
              Дізнатися більше
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomeScreen;
